import { createSlice } from '@reduxjs/toolkit'

interface campaignLimitState {
  usedTrials: number
}

const defaultState: campaignLimitState = {
  usedTrials: 0
}

export const campaignLimitSlice = createSlice({
  name: 'campaignLimit',
  initialState: defaultState,
  reducers: {
    incrementUsedTrials: state => {
      if (!state.usedTrials) {
        state.usedTrials = 1
      } else {
        state.usedTrials++
      }
    }
  }
})

export const { incrementUsedTrials } = campaignLimitSlice.actions

export { defaultState as campaignLimitDefaultState }
export default campaignLimitSlice.reducer
